/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Ownership state of a claimed hostname. Only meaningful on a CUSTOM_DOMAIN channel.
 * @export
 */
export const DomainStatus = {
    UNVERIFIED: 'UNVERIFIED',
    PENDING: 'PENDING',
    VERIFIED: 'VERIFIED'
} as const;
export type DomainStatus = typeof DomainStatus[keyof typeof DomainStatus];


export function instanceOfDomainStatus(value: any): boolean {
    for (const key in DomainStatus) {
        if (Object.prototype.hasOwnProperty.call(DomainStatus, key)) {
            if (DomainStatus[key as keyof typeof DomainStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DomainStatusFromJSON(json: any): DomainStatus {
    return DomainStatusFromJSONTyped(json, false);
}

export function DomainStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainStatus {
    return json as DomainStatus;
}

export function DomainStatusToJSON(value?: DomainStatus | null): any {
    return value as any;
}

export function DomainStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DomainStatus {
    return value as DomainStatus;
}

